import { render } from "./ViewAbonnePage.vue?vue&type=template&id=4058963d&ts=true"
import script from "./ViewAbonnePage.vue?vue&type=script&lang=ts"
export * from "./ViewAbonnePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__